import { $devConfig } from '../state/appConfig';

/**
 * Bearer header from the dev-config assistant token, or null when the token
 * is unset or `window` is unavailable (SSR). Shared by every authed client.
 */
export const getAssistantAuthHeader = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const { assistantApiToken } = $devConfig.getState();
  const token = typeof assistantApiToken === 'string' ? assistantApiToken.trim() : '';
  if (!token) {
    return null;
  }
  return `Bearer ${token}`;
};

/** JSON request headers with optional bearer auth attached. */
export const buildJsonHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const authHeader = getAssistantAuthHeader();
  if (authHeader) {
    headers.Authorization = authHeader;
  }
  return headers;
};
